<div class="overlay2" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <div class="pop2">
    <ng-container *ngIf="showProductDetails; then ProductLayout else ProductGroupLayout"></ng-container>
    <!--Product -->
    <ng-template #ProductLayout>
      <ng-container *ngIf="hasExtras; then ProductWithExtraLayout else BasicProductLayout"></ng-container>
      <!-- Product without extra items-->
      <ng-template #BasicProductLayout>
        <div class="product single">
          <header>
            <div *ngIf="product.has_image && !isModeTwo" class="img extra">
              <img [src]="product.image_path" class="ya_image">
            </div>
            <div *ngIf="!product.has_image || isModeTwo" class="img noimg">
              <h3>{{product.label}}</h3>
            </div>
          </header>
          <div class="content single">
            <sot-scroller-vertical>
              <header>
                <h1>{{product.label}}</h1>
                <div class="preis">
                  {{tempBasket.getTotalSum() | price}}
                </div>
              </header>
              <p *ngIf="product.details.description">{{product.details.description}}</p>
              <ng-container *ngIf="isItemTagEnabled">
                <div class="product-tag">
                  <div class="tag" *ngFor="let tag of itemTagsViewModel" id=" productTag{{tag.id}}">
                    <div class="tag-svg" [innerHTML]="tag.svg_html"></div>
                  </div>
                </div>
              </ng-container>
              <!--Extra: Base price & Deposit-->
              <ng-container *ngIf="(use_eCommerce && showBasePrice(product))||product.has_deposit">
                <div class="product-content_info">
                  <ng-container *ngIf="showBasePrice(product)">
                    <div class="product-baseUnit">
                      <span *ngIf="extraBaseUnit(product) === baseUnit.PIECE">{{(extraPricePerUnit(product)|price
                        )+
                        " /1" }}<span langkey="details_baseunit_piece"></span></span>
                      <span *ngIf="extraBaseUnit(product) === baseUnit.LITER">{{extraPricePerUnit(product)}}
                        <span langkey="details_baseunit_liter"></span></span>
                      <span *ngIf="extraBaseUnit(product)=== baseUnit.KILO">{{extraPricePerUnit(product)}}<span
                          langkey="details_baseunit_kilo"></span></span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="product.has_deposit">
                    <div class="deposit" [class.deposit-customized]="product.extra.length > 5">
                      <span [langkey]="deposit_langkey"></span>
                      <span class="info-value">{{product.deposit | price:"p c" }} </span>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
              <sot-properties [product]="product"></sot-properties>
            </sot-scroller-vertical>
          </div>
          <footer class="buttons">
            <div class="buttons">
              <a class="btn goback" (click)="backToDishListBtn()">
                <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
                <span langkey="button_back"></span>
              </a>
              <a class="btn action" [class.disabled]="!canAddProductToBasket"
                (click)="canAddProductToBasket ? checkRequirementAndAddToBasket() : null">
                <span langkey="button_add"></span>
                <div inlineSVG="sot/sot-icons.svg#sot-basket" flex [setSVGAttributes]="{class: 'basket-icon'}"></div>
              </a>
            </div>
          </footer>
        </div>
      </ng-template>
      <!-- Product with extra items -->
      <ng-template #ProductWithExtraLayout>
        <ng-container
          *ngIf="loadDefaultlayout(); then DefaultProductWithExtraLayout else AdditionalInfoLayout"></ng-container>
        <!-- Default View : Product and the list of extras items -->
        <ng-template #DefaultProductWithExtraLayout>
          <div class="product extra">
            <header>
              <div *ngIf="product.has_image" class="img extra">
                <img [src]="product.image_path" class="ya_image">
              </div>
              <div *ngIf="!product.has_image" class="img noimg">
                <h3>{{product.label}}</h3>
              </div>
            </header>
            <div class="content single">
              <header>
                <h1>{{product.label}}</h1>
                <div class="preis">
                  {{getBasketProductShownBasePrice(tempProduct) | price}}
                </div>
              </header>
              <p *ngIf="product.details.description">{{product.details.description}}</p>
              <div class="preference">
                <a class="btn info" (click)="toggleProductAdditionalInfo(true);DisplayAdditionalInfo(product)"
                  langkey="details_info"></a>
              </div>
              <!-- Extra groups-->
              <div class="extras-container">
                <div class="process" [class.hideSteps]="visibleExtragroups.length <= 1">
                  <sot-scroller-vertical [ngStyle]="{'height': product.details.description ? '540px' : '610px'}">
                    <ng-container *ngFor="let extraGroup of visibleExtragroups; let first = first; let last = last">
                      <div class="headline">
                        <h1>{{extraGroup.title}}</h1>
                        <div class="required">
                          <span><span
                              [langkey]="extraGroup.force_mode ? 'details_obligation' : 'details_selection'"></span>:
                          </span>{{getCount(extraGroup)}}/{{extraGroup.max_choices}}
                        </div>
                      </div>
                      <!-- Extra items-->
                      <div class="extras-inner" [class.small]="extraGroup.extra_items.length > 5">
                        <ng-container *ngFor=" let extra of extraGroup.extra_items">
                          <ng-container
                            *ngIf="extra.without_subitem; then SingleExtraTemplate else SubExtraTemplate"></ng-container>
                          <ng-template #SingleExtraTemplate>
                            <div class="extra"
                              [class.noimg]="!extra.product || !extra.product.has_image || !extra_as_image"
                              (click)="fadeOutExtraBySelectedTag(extra)? openResetExtraTagFilter(extra): onDishClick($event, extraGroup, extra)"
                              [class.not-avail]="!isExtraAvailable(extra)|| fadeOutExtraBySelectedTag(extra)"
                              [class.active]="isExtraSelected(extraGroup, extra)&& !fadeOutExtraBySelectedTag(extra)">
                              <div *ngIf="extra.product && extra.product.has_image && extra_as_image" class="img">
                                <img class="ya_image" [src]="extra.product.image_path">
                              </div>
                              <div class="extra-content container">
                                <div class="top-content extra-content--top">
                                  <header>
                                    <h2>{{extra.title}}</h2>
                                    <ng-container *ngIf="candisplayAdditionalInformation(extra.product)">
                                      <div class="info-content">
                                        <a class="btn"
                                          (click)="toggleExtraAdditionalInfo(true);DisplayAdditionalInfo(extra.product,extra.price,$event)"><span>i</span></a>
                                      </div>
                                    </ng-container>
                                  </header>
                                  <p *ngIf="extra.product">{{extra.product.details.description}}</p>
                                </div>
                                <ng-container *ngIf="isItemTagEnabled">
                                  <div class="extra-tag">
                                    <div class="tag"
                                      *ngFor="let extra_tag of GetExtraProductTagsByIds(extra.product.product_tag_ids)"
                                      id="extraProductTag{{extra_tag.id}}">
                                      <div class="tag-svg" [innerHTML]="extra_tag.svg_html"></div>
                                    </div>
                                  </div>
                                </ng-container>
                                <!--Extra: Base price & Deposit-->
                                <ng-container
                                  *ngIf="(use_eCommerce && showBasePrice(extra.product))||extra.has_deposit">
                                  <div class="product-content_info">
                                    <ng-container *ngIf="showBasePrice(extra.product)">
                                      <div class="product-baseUnit">
                                        <span
                                          *ngIf="extraBaseUnit(extra.product) === baseUnit.PIECE">{{(extraPricePerUnit(extra.product)|price
                                          )+
                                          " /1" }}<span langkey="details_baseunit_piece"></span></span>
                                        <span
                                          *ngIf="extraBaseUnit(extra.product) === baseUnit.LITER">{{(extraPricePerUnit(extra.product)|price
                                          )+
                                          " /1" }}
                                          <span langkey="details_baseunit_liter"></span></span>
                                        <span
                                          *ngIf="extraBaseUnit(extra.product)=== baseUnit.KILO">{{(extraPricePerUnit(extra.product)|price
                                          )+
                                          " /1" }}<span langkey="details_baseunit_kilo"></span></span>
                                      </div>
                                    </ng-container>
                                    <ng-container *ngIf="extra.has_deposit">
                                      <div class="deposit" [class.deposit-customized]="extra.sub_items.length > 5">
                                        <span [langkey]="deposit_langkey"></span>
                                        <span class="info-value">{{extra.deposit | price:"p c" }} </span>
                                      </div>
                                    </ng-container>
                                  </div>
                                </ng-container>
                                <footer>
                                  <div class="preis">
                                    {{extra.price | price:"+p c" }}
                                  </div>
                                  <sot-amount *ngIf="extraGroup.max_choices >= 1" [amount]="getCount(extraGroup, extra)"
                                    [max]="getCount(extraGroup, extra) + extraGroup.max_choices - getCount(extraGroup)"
                                    (amountChange)="setExtraCountTo($event, extraGroup, extra)"
                                    [class.small]="extraGroup.extra_items.length > 5">
                                  </sot-amount>
                                </footer>
                                <div
                                  *ngIf="!isExtraAvailable(extra)&&(fadeOutExtraBySelectedTag(extra) || !fadeOutExtraBySelectedTag(extra)) "
                                  class="not-available">
                                  <span langkey="details_not_available"></span>
                                </div>
                                <div *ngIf="isExtraAvailable(extra) && fadeOutExtraBySelectedTag(extra)"
                                  class="not-available">
                                  <span langkey="tags_article_labeling_text"></span>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template #SubExtraTemplate>
                            <ng-container *ngFor="let sub of extra.sub_items">
                              <div class="extra" (click)="onDishClick($event, extraGroup, extra, sub)"
                                [class.not-avail]="!isExtraAvailable(extra)"
                                [class.active]="isExtraSelected(extraGroup, extra, sub)">
                                <div class="title">
                                  {{extra.title}} ({{sub.title}})
                                </div>
                                <div class="amount">
                                  <sot-amount *ngIf="extraGroup.max_choices >= 1"
                                    [amount]="getCount(extraGroup, extra, sub)"
                                    [max]="getCount(extraGroup, extra, sub) + extraGroup.max_choices - getCount(extraGroup)"
                                    (amountChange)="setExtraCountTo($event, extraGroup, extra, sub)"
                                    [class.small]="extraGroup.extra_items.length > 5">
                                  </sot-amount>
                                </div>
                                <div class="preis">
                                  {{(extra.price + sub.price) | price:"+p c" }}
                                </div>
                                <div *ngIf="!isExtraAvailable(extra, sub)" class="not-available">
                                  <span langkey="details_not_available"></span>
                                </div>
                              </div>
                            </ng-container>
                          </ng-template>
                        </ng-container>
                      </div>
                    </ng-container>
                  </sot-scroller-vertical>
                </div>
              </div>
            </div>
            <footer class="buttons">
              <div class="summe">
                <span langkey="main_sum"></span>
                <div class="preis">{{tempBasket.getTotalSum() | price}}</div>
              </div>
              <div class="buttons">
                <a class="btn goback" (click)="backToDishListBtn()">
                  <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}">
                  </div>
                  <span langkey="button_back"></span>
                </a>
                <a class="btn action" [class.disabled]="!canAddProductToBasket"
                  (click)="canAddProductToBasket ? checkRequirementAndAddToBasket() : null">
                  <span langkey="button_add"></span>
                  <div inlineSVG="sot/sot-icons.svg#sot-basket" flex [setSVGAttributes]="{class: 'basket-icon'}"></div>
                </a>
              </div>
            </footer>
          </div>
        </ng-template>
        <!-- Additional informarion-->
        <ng-template #AdditionalInfoLayout>
          <ng-container
            *ngIf="showProductAdditionalInfo then ProductAdditionalInfoLayout else ExtraAdditionalInfoLayout "></ng-container>
          <!-- Additional information of selected product-->
          <ng-template #ProductAdditionalInfoLayout>
            <sot-productAdditionalInfo [product]="selectedProduct"
              [toggleShowInfo]="toggleProductAdditionalInfo.bind(this,false)">
            </sot-productAdditionalInfo>
          </ng-template>
          <!-- Additional information of selected extra-->
          <ng-template #ExtraAdditionalInfoLayout>
            <sot-productAdditionalInfo [product]="selectedProduct" [extraPrice]="extraPrice"
              [toggleShowInfo]="toggleExtraAdditionalInfo.bind(this,false)">
            </sot-productAdditionalInfo>
          </ng-template>
        </ng-template>
      </ng-template>
    </ng-template>
    <!-- List of product groups-->
    <ng-template #ProductGroupLayout>
      <div class="warengruppe">
        <header class="dialogTitle">
          <h1>{{selectedProductGroup.title}}</h1>
        </header>
        <div class="process" [class.hideSteps]="productGroups.length <= 1">
          <mat-horizontal-stepper #stepper [selectedIndex]="selectedProductGroupIndex">
            <ng-template matStepperIcon="edit" let-index="index">
              {{index + 1}} <!-- Completed && editiable && Not Selected Step;  -->
            </ng-template>
            <ng-template matStepperIcon="done" let-index="index">
              {{index + 1}} <!-- Completed && editable && Not Selected;  -->
            </ng-template>
            <ng-template matStepperIcon="number" let-index="index">
              {{index + 1}}<!-- Selected || Not Completed;  -->
            </ng-template>
            <ng-container *ngFor="let productGroup of productGroups; let first = first; let last = last">
              <mat-step>
                <header>
                  <div class="headline"></div>
                </header>
                <sot-scroller-vertical>
                  <div class="articles">
                    <ng-container *ngFor="let product of productGroup.products">
                      <sot-recommendationDish [title]="product.label" [image]="product.image"
                        [has_image]="product.has_image" [price]="product.price" [available]="product.available"
                        [schedule_active]="product.schedule_active" [schedule_hint]="product.schedule_hint"
                        (click)="product.onClick()"></sot-recommendationDish>
                    </ng-container>
                  </div>
                </sot-scroller-vertical>
              </mat-step>
            </ng-container>
          </mat-horizontal-stepper>
        </div>
        <footer class="buttons">
          <a class="btn goback" (click)="backBtn()">
            <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
            <span>{{buttonBack}}</span>
          </a>
          <a class="btn action" (click)="continueBtn()">
            <span langkey="button_continue"></span>
            <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
          </a>
        </footer>
      </div>
    </ng-template>
  </div>
</div>